import React, { useEffect } from 'react';
import Spinner from '../../../../CommonComponents/Spinner/Spinner';
import StoreAddress from '../../../../mobile/components/ReturnExchange/StoreAddress';
import { getStoreList, saveStoreAddress } from '../../../../actionCreators/returnExchange';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import './SelectReturnStore.scss';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import { saveUserAddress } from '../../../../actionCreators/returnExchange';
import GoogleAutoComplete from '../../../../CommonComponents/GoogleAutoComplete/GoogleAutoComplete';
// import { createReturn } from '../../../../actionCreators/returnExchange';

const mutators = {
  setFormattedAddress: (args, state, utils) =>
    utils.changeValue(state, 'customerAddress', () => args[0]),
};
function SelectReturnStore(props) {
  const {
    loadingNearByStore,
    storeList,
    dataLocale,
    setNearByAddress,
    // createReturn,
    userAddress,
    // returnOrderId,
    setIsExpandable,
    cartData,
    setFifthStep,
    getStoreList,
    cartCallsAction,
    saveUserAddress,
    saveStoreAddress,
    setFinalStep,
    nearByAddress,
  } = props;
  const returnAddress = sessionStorageHelper.getItem('returnUserAddress') || {};
  const {
    VISIT_NEARBY_STORE,
    FINAL,
    SELECT_NEARBY_STORE,
    PICK_A_NEARBY_STORE,
    NEARBY_STORES_FOUND,
    FIND_STORES_NEAR_MY_LOCATION,
    PROCEED,
    NO_STORES_FOUND_AT_THIS_LOCATION,
  } = dataLocale;
  const stores = (storeList && storeList.stores) || [];
  useEffect(() => {
    if (returnAddress && Object.keys(returnAddress).length > 0) {
      saveUserAddress(returnAddress);
    } else if (userAddress && Object.keys(userAddress).length > 0) {
      saveUserAddress(userAddress);
    }
  }, []);

  const handleStoreAddress = (e, storeDetails) => {
    setNearByAddress(e.target.value);
    let storeCode = sessionStorageHelper.getItem('returnStore') || {};
    storeCode = {
      ...storeCode,
      selectedStore: storeDetails,
    };
    sessionStorageHelper.setItem('returnStore', storeCode);
    saveStoreAddress(storeDetails);
    // setIsExpandable('final');
  };
  const fillInAddress = ({ postcode, formattedAddress }) => {
    const address = formattedAddress || postcode;
    if (address) getStoreList(address);
  };
  const handleProceed = () => {
    // const returnData = createItemReturnData(userAddress);
    // createReturn(returnOrderId, returnData);
    // setIsExpandable('Return Type');
    // setThirdStep(true);
    sessionStorageHelper.removeItem('refundMethod');
    let returnProduct = sessionStorageHelper.getItem('returnProduct') || {};
    returnProduct = {
      ...returnProduct,
      refundMethod: null,
      returnAction: null,
      returnMethod: null,
    };
    sessionStorageHelper.setItem('returnProduct', returnProduct);
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    returnStep = {
      ...returnStep,
      isExpandable: FINAL,
      finalStep: VISIT_NEARBY_STORE,
      fifthStep: false,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
    if (cartData?.items?.length > 0) cartCallsAction.deleteCart();
    setFifthStep(false);
    setIsExpandable(FINAL);
    setFinalStep(VISIT_NEARBY_STORE);
    // Screen stuck after click on continue but working fine on close modal click
    // overflow-hidden is remain in body classname
    document.body.classList.remove('overflow-hidden');
  };
  return (
    <div style={{ marginTop: '30px', marginLeft: '15px' }}>
      <div
        className="fw500 fsp14 lh-16 text-color_grey_black"
        style={{ marginLeft: '20px', fontSize: '18px', fontWeight: '600' }}
      >
        {SELECT_NEARBY_STORE}
      </div>
      <div
        className="fsp12 pd-b10 text-color_pale_black pd-t5 text-color-grey margin-t4"
        style={{ marginLeft: '20px' }}
      >
        {PICK_A_NEARBY_STORE}
      </div>
      <div className="google-location-map">
        <Form mutators={mutators} onSubmit={fillInAddress}>
          {({ handleSubmit, form }) => {
            return (
              <form
                noValidate
                className="shipping-address-form mr-b10"
                name="address"
                onSubmit={handleSubmit}
              >
                <GoogleAutoComplete
                  desktopFlow
                  customClass="google-location-address"
                  customInputClass="form-control"
                  fillInAddress={fillInAddress}
                  locationText={FIND_STORES_NEAR_MY_LOCATION}
                  mutators={form.mutators}
                  name="customerAddress"
                  placeholder={userAddress?.postcode}
                  onChange={fillInAddress}
                />
                {stores && stores.length ? (
                  <div
                    className="fsp14 fs13 mr-t12 fw600 margin-t10 text-color-grey margin-l20"
                    style={{ marginTop: '111px' }}
                  >
                    {stores.length} {NEARBY_STORES_FOUND}
                  </div>
                ) : (
                  <div
                    className="fsp14 mr-t15 fw500 text-color_brick_red margin-l20 margin-t10"
                    style={{ marginTop: '111px' }}
                  >
                    {loadingNearByStore ? '' : NO_STORES_FOUND_AT_THIS_LOCATION}
                  </div>
                )}
              </form>
            );
          }}
        </Form>
      </div>
      {!loadingNearByStore ? (
        Boolean(stores && stores.length) && (
          <div className="search-result mr-t10 margin-b30">
            {Boolean(stores && stores.length) &&
              stores.map((storeDetails, key) => {
                return (
                  <div
                    key={key}
                    className="md-radio pd-10 border-bottom margin-t15 margin-l35 margin-r20 display-flex"
                    style={{ padding: '10px' }}
                  >
                    <div className="margin-l10 margin-r30">
                      <input
                        checked={nearByAddress === storeDetails.address}
                        id={`reason-${key}`}
                        name="reason"
                        type="radio"
                        value={storeDetails.address}
                        onChange={e => handleStoreAddress(e, storeDetails)}
                      />
                    </div>
                    <label
                      htmlFor={`reason-${key}`}
                      style={{ height: 'auto', paddingRight: '0px' }}
                      title={key}
                    >
                      {storeDetails && (
                        <StoreAddress
                          desktopFlow
                          callStore={storeDetails.telephone}
                          dataLocale={dataLocale}
                          lat={storeDetails.latitude}
                          lng={storeDetails.longitude}
                          storeDetails={storeDetails}
                        />
                      )}
                    </label>
                  </div>
                );
              })}
          </div>
        )
      ) : (
        <Spinner />
      )}
      {nearByAddress && (
        <div style={{ position: 'sticky', textAlign: 'center', bottom: '15px' }}>
          {' '}
          <Button
            className="text-color-white bg-topaz no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase"
            style={{ padding: '8px 65px' }}
            onClick={handleProceed}
          >
            {' '}
            {PROCEED}{' '}
          </Button>{' '}
        </div>
      )}
    </div>
  );
}

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    dataLocale: state.locale,
    cartData,
    storeList: state.returnExchange.nearbyStore && state.returnExchange.nearbyStore.result,
    returnDetails: state.returnExchange.returnDetails,
  };
};

function mapDispatchToProps(dispatch) {
  return {
    getStoreList: postcode => dispatch(getStoreList(postcode)),
    saveStoreAddress: address => dispatch(saveStoreAddress(address)),
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
    saveUserAddress: address => dispatch(saveUserAddress(address)),
    // createReturn: (orderId, data) => dispatch(createReturn(orderId, data)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectReturnStore);
